import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import {
  personalExportLogFailure,
  personalExportLogRequest,
  personalExportLogSuccess,
} from './actions';
import { ExportInfoTypes } from './types';

function* personalExportLog({
  payload,
}: ReturnType<typeof personalExportLogRequest>) {
  const { token } = yield select(state => state.auth);

  try {
    yield call(api.post, 'v1/personal/exportar', null, {
      headers: { Authorization: `Bearer ${token}` },
    });

    yield put(personalExportLogSuccess());
  } catch (error) {
    yield put(personalExportLogFailure());
  }
}

export default all([
  takeLatest(ExportInfoTypes.PERSONAL_EXPORT_LOG_RESQUEST, personalExportLog),
]);
